import { ObservabilityControllerService } from 'data/openapi';
import { useQuery } from 'data/utils/useQuery';
import { QueryKeys } from 'data/constants';

export const useDashboardConfig = () => {
  return useQuery([QueryKeys.DASHBOARD], () => ObservabilityControllerService.getCluster());
};

// export const useDashboardConfigByNode = (pod: string, domain: string, options?: UseQueryOptions<any>) => {
//   return useQuery([QueryKeys.DASHBOARD, pod, domain], () => ObservabilityControllerService.getNode(pod, domain), {
//     ...options,
//   });
// };
